import React, { useEffect, useState } from "react";
import classnames from "classnames";
import Validator from "validator";
import { Stats } from "./Stats";
import { getCountries, getStates, getCities } from "../../actions/countriesActions";
import materialize from "materialize-css";
import { getZipCode } from "../../actions/zipcodeActions";


export const CompanyInformationExtended3 = (props) => {

  
  const [errorNombreEmpresa, setErrorNombreEmpresa] = useState('')
  const [errorRFC, setErrorRFC] = useState('');
  const [errorPrincipalActividad, setErrorPrincipalActividad] = useState('');
  const [errorCompanyStartOperationsDate, setCompanyStartOperationsDate] = useState('');
  const [errorCompanyExportCountries, setCompanyErrorExportCountries] = useState('');
  const [errorCompanyImportCountries, setCompanyErrorImportCountries] = useState('');
  const [errorCargo, setErrorCargo] = useState('');
  const [errorCodigoPostalEmpresa, setErrorCodigoPostalEmpresa] = useState('');
  const [errorTelefono, setErrorTelefono] = useState('');
  const [errorPais, setErrorPais] = useState('');
  const [errorEstado, setErrorEstado] = useState('');
  const [errorCiudadEmpresa, setErrorCiudadEmpresa] = useState('');

  const errorRazonSocial = '';
  //const errorColonia = '';
  const errorDomicilio = '';
  //const errorDomicilioNumero = '';
  const errorwwwEmpresa = '';
  const errorRedesSociales = '';




  const update = (e) => {

    props.update(e.target.id, e.target.value);
  };


  const validate = async () => {
    let valid = true;
    let language = localStorage.getItem("exmi_language");


    if (valid)
      props.nextStep();
  };

  return (
    <div>
      <div className="input-field col s12">
        <input
          onChange={update}
          value={props.form.nombreEmpresa}
          error={errorNombreEmpresa}
          id="nombreEmpresa"
          type="text"
           className={classnames("font-face-msb", {
            invalid: errorNombreEmpresa
          })}
        />
        <label htmlFor="nombreEmpresa">En que asociaciones o camaras empresariales participa?</label>
        <span className="red-text">{errorNombreEmpresa}</span>
      </div>

      <div className="input-field col s12">Cuenta con distintivos o certifiaciones?</div>
      <div className="col s12">
      <p>
      <label>
        <input name="group1" type="radio" onChange={update} checked/>
        <span>Si</span>
      </label>
    </p>
    <p>
      <label>
        <input name="group1" type="radio" onChange={update}  />
        <span>No</span>
      </label>
    </p> 
      </div>

      <div className="input-field col s12">La empresa a recibido algún reconocimiento o premio?</div>
      <div className="col s12">
      <p>
      <label>
        <input name="group1" type="radio" onChange={update} checked/>
        <span>Si</span>
      </label>
    </p>
    <p>
      <label>
        <input name="group1" type="radio" onChange={update}  />
        <span>No</span>
      </label>
    </p> 
      </div>

      <div className="input-field col s12">Desde que fecha eres afiiado en Cimejal? </div>
      <div className="col s12">
      <p>
      <label>
        <input name="group1" type="radio" onChange={update} checked/>
        <span>0 a 5 años </span>
      </label>
    </p>
    <p>
      <label>
        <input name="group1" type="radio" onChange={update}  />
        <span>6 a 10 años </span>
      </label>
    </p> 
    <p>
      <label>
        <input name="group1" type="radio" onChange={update}  />
        <span>11 a 15 años </span>
      </label>
    </p>  
    <p>
      <label>
        <input name="group1" type="radio" onChange={update}  />
        <span>16 a 20 años </span>
      </label>
    </p> 
    <p>
      <label>
        <input name="group1" type="radio" onChange={update}  />
        <span>21 a 25 años</span>
      </label>
    </p>                    
      </div>


      <Stats step={5} {...props} nextStep={validate} />
    </div>
  )
};